import { PluginManifest } from "./pluginTypes";

import careabdmfeManifest from "@app-manifest/care_abdm_fe";

export const pluginMap: PluginManifest[] = [
  careabdmfeManifest
];
